import { Component, OnInit } from '@angular/core';
import { Address } from '../../_models/address';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { User } from '../../_models/user';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-ao-seller',
  templateUrl: './edit-ao-seller.component.html',
  styleUrls: ['./edit-ao-seller.component.scss'],
})
export class EditAoSellerComponent implements OnInit {
  viewSeller: any = {};
  statesList: any;
  citiesList: any;
  password: string;
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText7: string = "";
  statusText8: string = "";
  statusText9: string = "";
  statusText10: string = "";

  constructor(private http: HttpClient, public user: User, private api: ApiIntegration, private router: Router, private route: ActivatedRoute, private g: Globals, private alertService: AlertService) {
    this.stateList();
    this.cityList();
    this.api.getCustomerSellerById(this.route.snapshot.params['id']).subscribe((data: any = []) => {
      this.viewSeller = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err)
    });
  }

  changeCityAndState() {
    this.api.getCityAndStateByPinCode(this.viewSeller.zipCode).subscribe((data: any) => {
      this.viewSeller.city = data.city;
      this.viewSeller.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() {
  }

  typeFirstName() {
    this.statusText1 = "";
    if (this.viewSeller.firstName == '' || this.viewSeller.firstName === null || this.viewSeller.firstName === undefined || this.viewSeller.firstName === 'undefined') {
      this.statusText1 = 'Please enter First Name';
    }
  }

  typeLastName() {
    this.statusText2 = "";
    if (this.viewSeller.lastName == '' || this.viewSeller.lastName === null || this.viewSeller.lastName === undefined || this.viewSeller.lastName === 'undefined') {
      this.statusText2 = 'Please enter Last Name';
    }
  }

  typeMobile() {
    this.statusText3 = "";
    if (this.viewSeller.mobile == '' || this.viewSeller.mobile === null || this.viewSeller.mobile === undefined || this.viewSeller.mobile === 'undefined') {
      this.statusText3 = 'Please enter Last Name';
    }
  }

  validateSellerCode() {
    this.statusText9 = "";
    if (this.viewSeller.sellerReferenceCode == '' || this.viewSeller.sellerReferenceCode === null || this.viewSeller.sellerReferenceCode === undefined || this.viewSeller.sellerReferenceCode === 'undefined') {
      this.statusText9 = 'Please enter Seller Code';
    }
  }

  validateMobile() {
    this.statusText3 = "";
    this.typeMobile();
    if (this.viewSeller.mobile !== 'undefined') {
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      this.http.post(environment.apiUrl + 'api/uniqueMobileNumber',
        this.viewSeller.mobile,
        { headers: header1 }).subscribe(data => {
          if (data['code'] == 200) {

          } else {
            if (data['code'] == 400) {
              this.statusText3 = data['message'];
            }
          }

        },
          (err: HttpErrorResponse) => {
            console.log(err);
            this.statusText3 = "Mobile Number  Exists";
          }
        )
    }
  }

  typeEmail() {
    if (this.viewSeller.email == '' || this.viewSeller.email === null || this.viewSeller.email === undefined || this.viewSeller.email === 'undefined') {
      this.statusText4 = 'Please enter email address';
      return false;
    }
    return true;
  }

  validateEmail() {
    this.statusText4 = "";
    this.typeEmail();

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email=' + this.viewSeller.email + "&userType=" +"USER",
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {
        } else {
          if (data['code'] == 400) {
            this.statusText4 = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.statusText4 = "uniqueEmail Failed, please re-try.";
        }
      )
  }

  createAddress() {
    this.statusText5 = "";
    if (this.viewSeller.address1 == '' || this.viewSeller.address1 === null || this.viewSeller.address1 === undefined || this.viewSeller.address1 === 'undefined') {
      this.statusText5 = 'Please enter address 1';
      return false;
    }
  }

  createCity() {
    this.statusText6 = "";
    if (this.viewSeller.city == '' || this.viewSeller.city === null || this.viewSeller.city === undefined || this.viewSeller.city === 'undefined') {
      this.statusText6 = 'Please enter city';
      return false;
    }
  }

  createState() {
    this.statusText7 = "";
    if (this.viewSeller.state == '' || this.viewSeller.state === null || this.viewSeller.state === undefined || this.viewSeller.state === 'undefined') {
      this.statusText7 = 'Please enter state';
      return false;
    }
  }

  createZip() {
    this.statusText8 = "";
    if (this.viewSeller.zip == '' || this.viewSeller.zip === null || this.viewSeller.zip === undefined || this.viewSeller.zip === 'undefined') {
      this.statusText8 = 'Please enter ZIP';
      return false;
    } else if (this.viewSeller.zip.length != 6) {
      this.statusText8 = 'ZIP code must be minimum 6 digits';
      return false;
    }
  }

  updateSeller() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createCustomerSeller', {
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "firstName": this.viewSeller.firstName,
      "companyName": this.viewSeller.companyName,
      "lastName": this.viewSeller.lastName,
      "mobile": this.viewSeller.mobile,
      "email": this.viewSeller.email,
      "sellerReferenceCode": this.viewSeller.sellerReferenceCode,
      "password": this.password,
      "address1": this.viewSeller.address1,
      "address2": this.viewSeller.address2,
      "city": this.viewSeller.city,
      "state": this.viewSeller.state,
      "sellerId": this.viewSeller.sellerId,
      "zipCode": this.viewSeller.zipCode,
      "status": "ACTIVE"
    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == "200") {
        this.router.navigate(['/admin/viewAoSeller/' + this.viewSeller.sellerId]);
        this.alertService.success('Seller', 'Updated Successfully');
      } else {
        this.alertService.error(data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }
}
